import { render, staticRenderFns } from "./SaveTheReturnDispatch.vue?vue&type=template&id=47762618&scoped=true&"
import script from "./SaveTheReturnDispatch.vue?vue&type=script&lang=js&"
export * from "./SaveTheReturnDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47762618",
  null
  
)

export default component.exports